import { axios } from '@Root/API'

export const getReports = (type, params) => {
  return axios.get(`pre-hesa-checks/reports/${type}`, { params })
}
